// extracted by mini-css-extract-plugin
export var errorIcon = "_oh-1";
export var nameLogo = "_oh-0";